import './Organizer.scss';
import Sponzor1 from '../../assets/sponzor1.png';
import Sponzor2 from '../../assets/sponzor2.jpg';
import Sponzor3 from '../../assets/sponzor3.jpg';
import Sponzor4 from '../../assets/sponzor4.jpg';
import Sponzor5 from '../../assets/sponzor5.jpg';
import Sponzor6 from '../../assets/sponzor6.jpg';
import Sponzor7 from '../../assets/sponzor7.jpg';
import Sponzor8 from '../../assets/sponzor8.jpg';
import Sponzor9 from '../../assets/sponzor9.jpg';
import Sponzor10 from '../../assets/sponzor10.jpg';
import Sponzor11 from '../../assets/sponzor11.jpg';
import Sponzor12 from '../../assets/sponzor12.png';
import Sponzor13 from '../../assets/sponzor13.png';
import Sponzor14 from '../../assets/sponzor14.png';
import Sponzor15 from '../../assets/sponzor15.png';
import Sponzor16 from '../../assets/sponzor16.png';
import Sponzor17 from '../../assets/sponzor17.png';
import Sponzor18 from '../../assets/sponzor18.png';
import Sponzor19 from '../../assets/sponzor19.jpg';
import Sponzor20 from '../../assets/sponzor20.png';
import Sponzor21 from '../../assets/sponzor21.svg';
import Sponzor22 from '../../assets/sponzor22.jpg';
import Sponzor23 from '../../assets/sponzor23.png';
import Sponzor24 from '../../assets/sponzor24.png';
import Sponzor25 from '../../assets/sponzor25.png';
import Sponzor26 from '../../assets/sponzor26.png';
import Sponzor27 from '../../assets/sponzor27.png';
import Sponzor28 from '../../assets/sponzor28.png';

const Organizer = (props: any) => {
  return (
    <div className="organizer">
      <div className="container">
        <p className={`title ${props.titleClass}`}>Sponzori</p>
        {/* <p className="subtitle">7. SRPSKI DANI OSIGURANJA</p> */}

        {/* <div className="img-box">
          <a href="https://saga.rs/">
            <img className="img" src={Sponzor1} />
          </a>
        </div> */}
        {/* <div className="img-box">
          <a href="https://www.halkbank.rs/Pocetna.1.html">
            <img className="img-second" src={Sponzor2} />
          </a>
        </div> */}
        <div className="img-list">
          {/* <div className="img-list-wrapper">
            <a href="https://www.eurobank-direktna.rs/pocetna.1.html">
              <img className="img" src={Sponzor3} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://www.srpskabanka.rs/">
              <img className="img" src={Sponzor4} />
            </a>
          </div> */}
          {/* <div className="img-list-wrapper">
            <a href="https://www.procreditbank.rs/">
              <img className="img" src={Sponzor5} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://www.otpbanka.rs/">
              <img className="img" src={Sponzor6} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://www.addiko.rs/">
              <img className="img" src={Sponzor7} />
            </a>
          </div> */}
          <div className="img-list-wrapper">
            <a href="https://saga.rs/">
              <img className="img" src={Sponzor1} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://www.comtrade.com/">
              <img className="img" src={Sponzor8} />
            </a>
          </div>
          {/* <div className="img-list-wrapper">
            <a href="https://altabanka.rs/">
              <img className="img" src={Sponzor10} />
            </a>
          </div> */}
          {/* <div className="img-list-wrapper">
            <a href="https://normasoft.net/">
              <img className="img" src={Sponzor12} />
            </a>
          </div> */}
          <div style={{ marginTop: 14 }}>
            <div className="img-list-wrapper">
              <a href="http://www.salviol.com">
                <img className="img-second" src={Sponzor24} />
              </a>
            </div>
          </div>
          <div className="img-list-wrapper">
            <a href="https://blinking.id/">
              <img className="img-second" src={Sponzor14} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://quiddita.rs/">
              <img className="img-second" src={Sponzor27} style={{ marginTop: '33px' }} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://consumer.huawei.com/rs/">
              <img className="img-second" src={Sponzor22} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://coredev.rs/">
              <img className="img-second" src={Sponzor28} />
            </a>
          </div>
          {/*<div className="img-list-wrapper">
            <a href="https://www.energosoft.rs/">
              <img className="img-second" src={Sponzor21} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="http://www.yumit.rs/">
              <img className="img-second" src={Sponzor23} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="http://www.salviol.com">
              <img className="img-second" src={Sponzor24} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://atos.net/en/">
              <img className="img-second" src={Sponzor25} style={{ width: '115px' }} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="http://oriontelekom.rs/poslovni">
              <img className="img-second" src={Sponzor26} />
            </a>
          </div> */}
          {/* <div className="img-list-wrapper">
            <a href="https://blinking.id/">
              <img className="img-second" src={Sponzor14} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://eviden.com/">
              <img className="img-second" src={Sponzor15} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://www.esolutions.rs/">
              <img className="img-third" src={Sponzor16} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://www.halcom.com/rs/">
              <img className="img" src={Sponzor9} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://asseco.com/">
              <img className="img" src={Sponzor13} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://www.dnb.com/">
              <img className="img" src={Sponzor17} />
            </a>
          </div>
          <div className="img-list-wrapper">
            <a href="https://inception.rs/">
              <img className="img-five" src={Sponzor18} />
            </a>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Organizer;
